import { Suspense, lazy } from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Hero from '../sections/Hero';
import Highlight from '../sections/Highlight';

// Lazy sections
const Model = lazy(() => import('../sections/Model'));
const ProductCarousel = lazy(() => import('../sections/ProductCarousel'));
const Features = lazy(() => import('../sections/Features'));
const HowItWorks = lazy(() => import('../sections/HowItWorks'));

const HomePage = () => {
  return (
    <main>
      <Navbar />
      <Hero />


        <Highlight />

      <Model />


        <ProductCarousel />


        <Features />

     
        <HowItWorks />

      <Footer />
    </main>
  );
};

export default HomePage;
